import type { PatientListRawPatient } from '../types/Patients.types';
import { PatientDisplayUtils } from './PatientDisplay.utils';

interface PatientListItemConfig {
    title: string;
    subtitle: string;
}

export class PatientListItemUtils {
    static getPatientListItemConfig(patient: PatientListRawPatient): PatientListItemConfig {
        const title = PatientDisplayUtils.getPatientName(patient);

        const birthday = PatientDisplayUtils.getPatientBirthday(patient);
        const age = PatientDisplayUtils.getPatientAge(patient);
        const gender = PatientDisplayUtils.getPatientGender(patient);

        const subtitle = `${birthday}, ${age}, ${gender}`;

        return { title, subtitle };
    }
}
